import {
  BlogPostsCreateInterface,
  BlogPostsErrorsInterface,
  BlogPostsFilterInterface,
} from '../../types/blog-posts-interface'

export const defaultValues: BlogPostsCreateInterface = {
  name: '',
  description: '',
  path: '',
  image: null,
  categories: [],
}

export const defaultErrors: BlogPostsErrorsInterface = {
  name: '',
  categories: '',
  path: '',
  image: '',
  description: '',
  postedAt: '',
  activatedAt: '',
}

export const defaultFilters: BlogPostsFilterInterface = {
  isActive: undefined,
  searchBy: '',
}
